export default "__VITE_ASSET__CEz1aIBG__"